import { render, staticRenderFns } from "./UsersForm.vue?vue&type=template&id=61890a79&"
import script from "./UsersForm.vue?vue&type=script&lang=js&"
export * from "./UsersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports